import {NgModule} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {AppCommonModule} from '../common/common.module';
import {RouterModule} from '@angular/router';
import {SecureRoutes} from './secure.routing';
import {SecureComponent} from './secure.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {BlockUIModule} from 'primeng/blockui';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {PanelModule} from 'primeng/panel';
import {RfqsComponent} from './dashboard/rfqs/rfqs.component';
import {BreadcrumbModule} from 'primeng/breadcrumb';
import {DashboardContentComponent} from './dashboard/content/dashboard-content.component';
import {TableModule} from 'primeng/table';
import {ButtonModule} from 'primeng/button';
import {ProgressBarModule} from 'primeng/progressbar';
import {RecipientOverlayComponent} from './dashboard/rfqs/recipient-overlay/recipient-overlay.component';
import {DialogModule} from 'primeng/dialog';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {InputTextModule} from 'primeng/inputtext';
import {OrdersComponent} from './orders/orders.component';
import {DividerModule} from 'primeng/divider';
import {RippleModule} from 'primeng/ripple';
import {RfqComponent} from './dashboard/rfqs/rfq/rfq.component';
import {QuotationComponent} from './dashboard/rfqs/quotation/quotation.component';
import {DropdownModule} from 'primeng/dropdown';
import {ProductListOverlayComponent} from './dashboard/rfqs/quotation/product-list/product-list-overlay.component';
import {RatingModule} from 'primeng/rating';
import {InputNumberModule} from 'primeng/inputnumber';
import {KeyFilterModule} from 'primeng/keyfilter';
import {PaginatorModule} from 'primeng/paginator';
import {CalendarModule} from 'primeng/calendar';
import {CheckboxModule} from 'primeng/checkbox';
import {SelectButtonModule} from "primeng/selectbutton";

@NgModule({
    declarations: [
        SecureComponent,
        DashboardComponent,
        DashboardContentComponent,
        RfqsComponent,
        RfqComponent,
        QuotationComponent,
        ProductListOverlayComponent,
        RecipientOverlayComponent,
        OrdersComponent
    ],
    imports: [
        AppCommonModule,
        ButtonModule,
        CheckboxModule,
        CommonModule,
        DialogModule,
        FormsModule,
        InputTextModule,
        ReactiveFormsModule,
        RouterModule.forChild(SecureRoutes),
        BlockUIModule,
        ProgressSpinnerModule,
        PanelModule,
        BreadcrumbModule,
        TableModule,
        ProgressBarModule,
        DividerModule,
        RippleModule,
        DropdownModule,
        RatingModule,
        InputNumberModule,
        KeyFilterModule,
        PaginatorModule,
        ReactiveFormsModule,
        CalendarModule,
        SelectButtonModule
    ],
    providers: [
        DatePipe
    ]
})
export class SecureModule {
}
